var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDateTimeArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.399,
    height: 11.599,
    viewBox: "0 0 17.399 11.599",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5",
    d: "M16.8 9.766a.878.878 0 0 1-.677-.29L11.29 4.643a.957.957 0 1 1 1.353-1.353l4.833 4.833a.934.934 0 0 1 0 1.353.878.878 0 0 1-.677.29z",
    transform: "rotate(90 13.283 7.116)",
    style: {
      fill: "#182e37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6",
    d: "M6.967 9.766a.878.878 0 0 1-.677-.29.934.934 0 0 1 0-1.353l4.833-4.833a.957.957 0 1 1 1.353 1.353L7.643 9.476a.878.878 0 0 1-.677.29z",
    transform: "rotate(90 13.2 7.2)",
    style: {
      fill: "#182e37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7",
    d: "M11.967 20.4a.913.913 0 0 1-.967-.968V3.967a.967.967 0 0 1 1.933 0v15.465a.913.913 0 0 1-.966.968z",
    transform: "rotate(90 13.283 7.116)",
    style: {
      fill: "#182e37"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateTimeArrow);
export default __webpack_public_path__ + "static/media/DateTimeArrow.72e6b7642e4a2d2bfdbe7049146e2876.svg";
export { ForwardRef as ReactComponent };